export default __webpack_public_path__ + "static/media/Who-We-Are.de87bfe3.png";